import { type SingleSelectedValueFilter } from '../types'
import DeadlineDateFilter from './DeadlineDateFilter'

const DeadlineDateBeforeFilter = (props: SingleSelectedValueFilter) => {
  return (
    <DeadlineDateFilter {...props} rangeType='Deadline before' />
  )
}

export default DeadlineDateBeforeFilter
